import React from 'react';
import PropTypes from 'prop-types';
import { Notification } from '@telus-uds/components-web';
import { Text } from '../../orderDetails/css';

const MessageNotification = ({ message, variant }) => {
  // Map TDS variant to UDS variant
  let udsVariant = {};
  if (variant === 'error') {
    udsVariant = { validation: 'error' };
  } else if (variant === 'success') {
    udsVariant = { style: 'success' };
  } else if (variant === 'warning') {
    udsVariant = { style: 'warning' };
  } else if (variant === 'info') {
    udsVariant = { style: 'subtle' };
  }
  
  return (
    <Notification variant={udsVariant}>
      {/* 24px matches the notification icon so the text centres against it */}
      <div style={{ display: 'flex', alignItems: 'center', minHeight: 24 }}>
        <Text bold style={{ margin: 0 }}>
          {message}
        </Text>
      </div>
    </Notification>
  );
};

MessageNotification.propTypes = {
  message: PropTypes.string.isRequired,
  variant: PropTypes.string.isRequired
};
export default MessageNotification;
